/**
 * This file is here to facilitate easier mocks when testing
 */
export default window;
